/**
 * @generated SignedSource<<aaf8c7e28fb579a2aa52efb597df68d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Payment_checkout$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckout_checkout">;
  readonly " $fragmentType": "Payment_checkout";
};
export type Payment_checkout$key = {
  readonly " $data"?: Payment_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Payment_checkout",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckout_checkout"
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "57318fac93e8b971addea54b912d391c";

export default node;
